import ReactRailsUJS from "react_ujs"
import Pricing from "./react-components/pricing/Pricing"

const componentsContext = {
  Pricing: Pricing,
}

ReactRailsUJS.useContext(componentsContext)
ReactRailsUJS.getConstructor = (name) => componentsContext[name]
